module.exports = __webpack_public_path__ + "img/J1.dcd57da0.png";